{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/color';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a color swatch.';
export const isSubpage = true;

# useColorSwatch

<PageDescription>{docs.exports.useColorSwatch.description}</PageDescription>

```tsx render files={["starters/hooks/src/ColorSwatch.tsx", "starters/hooks/src/ColorSwatch.css"]}
"use client";
import {ColorSwatch} from 'hooks-starter/ColorSwatch';

<ColorSwatch color="#f00a" />
```

## API

<FunctionAPI function={docs.exports.useColorSwatch} links={docs.links} />

### AriaColorSwatchProps

<InterfaceType {...docs.exports.AriaColorSwatchProps} />

### ColorSwatchAria

<InterfaceType {...docs.exports.ColorSwatchAria} />
